<template>
  <!-- #pjw Dairy Direct -->
  <div class="one_step">
    <div class="step_shell for_pb outcome_box">
      <p class="highlighted">Congratulations!</p>
      <p v-if="product==='dairy'">Based on the information you’ve provided, we can approve your online Dairy Direct loan application.</p>
      <p v-else>Based on the information you’ve provided, we can approve your online Sheep & Beef loan application.</p>
      <p>
        We just need to confirm your details and loan structure, request
        supporting documents, and complete some further checks.
      </p>
      <p>In the meantime, here’s a summary of your loan application request:</p>
      <p class="totals">
        Total term loan amount: {{ total_amount | currency }}
        <br />
        Monthly interest only repayments*:
        {{
          monthly_interest
            | currency({ fractionCount: 2, avoidEmptyDecimals: "" })
        }}
        <br />
        Monthly P&I repayments**:
        {{
          monthly_repayment
            | currency({ fractionCount: 2, avoidEmptyDecimals: "" })
        }}
      </p>
      <p>
        * Based on interest only repayments over a 5-year term at {{interestRate}}% p.a.
        <br />** Based on principal and interest repayments over a 25-year term
        at {{interestRate}}% p.a.
      </p>      
      <p>
        To help us get started on confirming your details, please send the
        following information to
        <a
          href="mailto:ruraldirect@heartland.co.nz"
        >ruraldirect@heartland.co.nz</a>:
      </p>
      <ul>
        <li>Most recent financial statements (not less than 9 months old)</li>
        <li>Statement of financial position (not less than 3 months old)</li>
        <li>
          12-month cashflow budget, if you are applying for a revolving credit
          facility
        </li>
        <li>Sale and purchase agreement (if applicable)</li>
        <li>Registered valuation of the farm (if applicable)</li>
      </ul>
      <p>
        We'll also need to verify your identification using biometrics, so we'll
        send the link to your mobile phone via SMS. You’ll receive an email from
        us shortly outlining the information above.
      </p>
    </div>
  </div>
  <!-- <div class="one_step">
    <div class="step_shell for_pb outcome_box">
      <p class="highlighted">Congratulations {{ fullName }}!</p>      
      <p>
        Based on the information you’ve provided, we can approve your online
        Sheep & Beef Direct loan application.
      </p>
      <p>
        We just need to confirm your details and loan structure, request
        supporting documents, and complete some further checks.
      </p>
      <p>In the meantime, here’s a summary of your loan application request:</p>
      <p class="totals">
        Total term loan amount: {{ total_amount | currency }}
        <br />
        Monthly interest only repayments*:
        {{
          monthly_interest
            | currency({ fractionCount: 2, avoidEmptyDecimals: "" })
        }}
        <br />
        Monthly P&I repayments**:
        {{
          monthly_repayment
            | currency({ fractionCount: 2, avoidEmptyDecimals: "" })
        }}
      </p>
      <p>
        * Based on interest only repayments over a 5-year term at 4.45% p.a.
        <br />** Based on principal and interest repayments over a 25-year term
        at 4.45% p.a.
      </p>      
      <p>
        To help us get started on confirming your details, please send the
        following information to
        <a href="mailto:ruraldirect@heartland.co.nz"
          >ruraldirect@heartland.co.nz</a
        >:
      </p>
      <ul>
        <li>Most recent financial statements (not less than 9 months old)</li>
        <li>Statement of financial position (not less than 3 months old)</li>
        <li>
          12-month cashflow budget, if you are applying for a revolving credit
          facility
        </li>
        <li>Sale and purchase agreement (if applicable)</li>
        <li>Registered valuation of the farm (if applicable)</li>
      </ul>
      <p>
        We'll also need to verify your identification using biometrics, so we'll
        send the link to your mobile phone via SMS. You’ll receive an email from
        us shortly outlining the information above.
      </p>
    </div>
  </div> -->
</template>

<script>
import libraryMixin from "./library_mixin";

export default {
  mixins: [libraryMixin],
  props: {
    current: {
      type: Boolean,
      default: false,
    },
    header: {
      type: String,
      default: "",
    },
    fullName: {
      type: String,
      default: "",
    },
  },
  data() {
    return {
      stepIndex: 7,
      valid: false,
      product: null,  //#pjw new fields
      interestRate: null,
    };
  },
  watch: {},
  computed: {
    appName: function appName() {
      return this.product === "dairy" ? "Dairy Direct" : "Sheep & Beef Direct";
    },
    total_amount: function total_amount() {
      return this.$parent.$parent.application.loanData.total_amount;
    },
    monthly_interest: function monthly_interest() {
      return this.$parent.$parent.application.loanData.monthly_interest;
    },
    monthly_repayment: function monthly_repayment() {
      return this.$parent.$parent.application.loanData.monthly_repayment;
    },
  },
  updated: function() {},
  methods: {},
  created: function() {    
    var app = this.$parent.$parent.application;
    this.product = app.product; 
    this.interestRate = app.interestRate
  },
};
</script>
